/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import moment from 'moment';
import { TransactionsService } from '../services/transactions.service';

const transactionsState = {
  transactions: [],
  state: '',
  conf: {
    direction: 'desc',
    page: 1,
    per_page: 20,
    max_page: 1,
    item: '',
    start: moment(moment().subtract(1, 'months')).format('Y-MM-DD'),
    end: moment().format('Y-MM-DD'),
    email: '',
    product_id: '',
    transaction_id: '',
  },
};

const mutations = {
  /**
   * Set the list of transactions
   * @param {Object} state
   * @param {Array} transactions
   */
  setTransactions(state, transactions) {
    state.transactions = transactions;
  },
  /**
   * Set transactions state
   * @param {Object} state
   * @param {String} type
   */
  setState(state, type) {
    state.state = type;
  },
  /**
   * Set the config
   * @param {Object} state
   * @param {Object} conf
   */
  setConf(state, conf) {
    state.conf = conf;
  },
};

const getters = {
  /**
   * Get the list of transactions
   * @return {Array}
   */
  list: state => state.transactions,
  /**
   * Get the current state of the transactionslist
   * @return {String}
   */
  state: state => state.state,
  /**
   * Get the current config
   * @return {Object}
   */
  conf: state => state.conf,
  /**
   * Get a compiled list of pagination
   * @return {Object}
   */
  pagination: state => ({ page: state.conf.page, per_page: state.conf.per_page, max_page: state.conf.max_page }),
};

const actions = {
  /**
   * Get transactions
   * @param {Object} obj
   * @param {Function} obj.commit
   * @param {Function} obj.dispatch
   * @param {Object} obj.state
   * @param {Object} params
   * @return {Boolean}
   */
  getTransactions: async ({ commit, dispatch, state }, params = {}) => {
    let payload;

    if (!params.skipConf) {
      payload = JSON.parse(JSON.stringify(state.conf));
      delete payload.max_page;
    } else {
      payload = JSON.parse(JSON.stringify(params));
      delete payload.skipConf;
    }

    if (params.skipState) {
      delete payload.skipState;
    }

    try {
      if (!params.skipLoading) {
        commit('setState', 'loading');
      }
      const data = await TransactionsService.getTransactions(payload);
      if (!params.skipState) {
        commit('setTransactions', data.transactions);
      }
      commit('setState', '');
      if (!params.skipConf) {
        dispatch('updateConf', {
          page: data.pagination.current_page,
          max_page: data.pagination.max_page,
        });
      }
      return data;
    } catch (e) {
      return false;
    }
  },
  exportTransactions: async (_, payload) => {
    try {
      const data = TransactionsService.exportTransactions(payload);
      return data;
    } catch (e) {
      return false;
    }
  },
  /**
   * Refund a transaction
   * @param {Object} obj
   * @param {String} id
   * @return {Boolean}
   */
  refundTransaction: async ({}, id) => {
    try {
      await TransactionsService.refundTransaction(id);
      return true;
    } catch (e) {
      return false;
    }
  },
  /**
   * Get and return a transaction
   * @param {Object} obj
   * @param {String} id
   * @return {Object}
   */
  // eslint-disable-next-line
  getTransaction: async ({}, id) => {
    try {
      const data = await TransactionsService.getTransaction(id);
      return data;
    } catch (e) {
      return {};
    }
  },
  /**
   * Get and return a transaction
   * @param {Object} obj
   * @param {String} id
   * @return {Object}
   */
  // eslint-disable-next-line
  getTransactionTicket: async ({}, id) => {
    try {
      const data = await TransactionsService.getTransactionTicket(id);
      return data;
    } catch (e) {
      return null;
    }
  },
  /**
   * Update config
   * @param {Object}    obj - Object
   * @param {Function}  obj.commit
   * @param {Object}    obj.state
   * @param {Object}    options
   */
  updateConf: ({ commit, state }, options) => {
    const conf = Object.assign(JSON.parse(JSON.stringify(state.conf)), options);
    commit('setConf', conf);
  },
  /**
   * Reset the config
   */
  resetConf: ({ dispatch, commit }, options) => {
    const conf = Object.assign({
      direction: 'desc',
      page: 1,
      per_page: 20,
      max_page: 1,
      item: '',
      start: moment(moment().subtract(1, 'months')).format('Y-MM-DD'),
      end: moment().format('Y-MM-DD'),
      email: '',
      product_id: '',
      transaction_id: '',
    }, options);
    dispatch('updateConf', conf);
    commit('setTransactions', []);
  },
};

export default {
  namespaced: true,
  state: transactionsState,
  mutations,
  getters,
  actions,
};
